import { IssueTemplateEntity } from '../../../types/apiDomain';

const getIssueTemplateName = ({ name, id }: IssueTemplateEntity): string => name || id;

export default getIssueTemplateName;
